var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 0h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 8c3.24 0 5.935 2.156 6.5 5-.565 2.844-3.26 5-6.5 5S5.565 15.844 5 13c.565-2.844 3.26-5 6.5-5Zm0 8.889c2.523 0 4.711-1.614 5.273-3.889-.564-2.273-2.751-3.884-5.273-3.884S6.79 10.727 6.227 13c.562 2.275 2.75 3.888 5.273 3.889Zm0-1.389c-1.493 0-2.704-1.12-2.704-2.5s1.21-2.5 2.704-2.5c1.493 0 2.704 1.12 2.704 2.5s-1.21 2.5-2.704 2.5Zm0-1.111c.83 0 1.502-.622 1.502-1.389s-.672-1.389-1.502-1.389-1.502.622-1.502 1.389.672 1.389 1.502 1.389Z",
  fill: "#00B177",
  fillRule: "nonzero"
}))));
export default SvgEye;